import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-sc",
  "use": "icon-icon-sc-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-sc\">\n  <path fill=\"#fff\" d=\"M0 0h512v512H0Z\" />\n  <path fill=\"#d92223\" d=\"M0 512V0h512v170.7z\" />\n  <path fill=\"#fcd955\" d=\"M0 512V0h341.3z\" />\n  <path fill=\"#003d88\" d=\"M0 512V0h170.7z\" />\n  <path fill=\"#007a39\" d=\"m0 512 512-170.7V512Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol